import { render, staticRenderFns } from "./CrewListModal.vue?vue&type=template&id=5253c392&scoped=true"
import script from "./CrewListModal.vue?vue&type=script&lang=js"
export * from "./CrewListModal.vue?vue&type=script&lang=js"
import style0 from "./CrewListModal.vue?vue&type=style&index=0&id=5253c392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5253c392",
  null
  
)

export default component.exports